import React, { forwardRef } from 'react';

const RoomBedIcon = forwardRef(({
  size = 24,
  color = 'currentColor',
  mirrored = false,
  weight: _weight,
  ...props
}, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 256 256"
    fill={color}
    transform={mirrored ? 'scale(-1, 1)' : undefined}
    aria-hidden="true"
    {...props}
  >
    <path d="M57 111V62c0-10 8-18 18-18h106c10 0 18 8 18 18v49h-15V64H72v47H57Z" />
    <path d="M72 108V91c0-11 9-20 20-20h20c9 0 16 7 16 16v21H72Zm56 0V87c0-9 7-16 16-16h20c11 0 20 9 20 20v17h-56Z" />
    <path d="M53 106h150c7 0 13 4 16 11l17 39v39c0 5-4 9-9 9h-8v17c0 5-4 9-9 9s-9-4-9-9v-17H55v17c0 5-4 9-9 9s-9-4-9-9v-17h-8c-5 0-9-4-9-9v-39l17-39c3-7 9-11 16-11Zm-15 58v22h180v-22H38Z" />
  </svg>
));

RoomBedIcon.displayName = 'RoomBedIcon';

export default RoomBedIcon;
